import axios from "axios";
import { Endpoints } from "../../models/Endpoints";
import Config from "react-native-config";

export async function getEndpoints(): Promise<Endpoints> {
  const endpoints = await axios.get(process.env.ENDPOINTS_URL);
  return endpoints.data;
}
